import { BaseUrl } from "../../BaseUrl/BaseUrl";
import { getApiWithoutAuthorization } from "../ApiMethod/ApiMethod";


export const GetPanditBookingPaymentReceipt = async (OrderID, ServiceType) => {
    const url = `${BaseUrl}/GetPanditBookingPaymentReceipt?OrderID=${OrderID}&ServiceType=${ServiceType}`;
    const res = await getApiWithoutAuthorization(url);
    return res;
};
